import GlobalButton from '../buttons/GlobalButton';
import { GlobalButtonVariant } from '../buttons/GlobalButton';

export interface FormCancelButtonProps {
  action: () => void;
  disabled?: boolean;
  label?: string;
}

const FormCancelButton = ({
  action,
  disabled = false,
  label = 'Cancelar',
}: FormCancelButtonProps) => (
  <GlobalButton
    variant={GlobalButtonVariant.secondaryButton}
    action={action}
    disabled={disabled}
  >
    {label}
  </GlobalButton>
);

export default FormCancelButton;
